import { CianSmall16, Image, User16, Zastroishik16, Agent24 } from '@cian/ui-kit';
import React from 'react';
import classNames from 'classnames';

import { TAgentIconType } from '../../../types/offer-card';
import styles from './AgentAvatar.css';

interface IAgentAvatarProps {
  promoted: boolean;
  icon: TAgentIconType;
  imageLink?: string;
}

export const AgentAvatar: React.FC<IAgentAvatarProps> = ({ promoted, imageLink, icon }) => {
  return (
    <div className={classNames(styles['cont'], promoted && styles['top'], icon === 'cian' && styles['cian-ico'])}>
      {imageLink && <Image objectFit="contain" src={imageLink} />}
      {!imageLink && icon === 'cian' && <CianSmall16 />}
      {!imageLink && icon === 'builder' && <Zastroishik16 />}
      {!imageLink && icon === 'person' && <User16 />}
      {!imageLink && icon === 'company' && <Agent24 />}
    </div>
  );
};
